module.exports = __webpack_public_path__ + "static/5-0a1c886a068973739987184551d8a867.jpg";